// extracted by mini-css-extract-plugin
module.exports = {"infoBox":"PageHeader_infoBox__Dl2Ne","limitTextHeight":"PageHeader_limitTextHeight__biCwH","upArrow":"PageHeader_upArrow__xyfWk","downArrow":"PageHeader_downArrow__KfkV0"};